import { render, staticRenderFns } from "./TableTable.vue?vue&type=template&id=fcb839fa"
import script from "./TableTable.vue?vue&type=script&lang=js"
export * from "./TableTable.vue?vue&type=script&lang=js"
import style0 from "./TableTable.vue?vue&type=style&index=0&id=fcb839fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports